import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGatlingComponent } from './simple-icons-gatling.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGatlingComponent ],
    exports:      [ SimpleIconsGatlingComponent ],
    bootstrap:    []
})
export class SimpleIconsGatlingModule {}
